// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3it3X","inner":"Form_inner__33qYh","range":"Form_range__2KDsQ","name":"Form_name__ZY6xM","actions":"Form_actions__2yrfh"};